<template>
  <div class="performance-view" v-if="item">
    <cpo-performance-header :item="item" />
    <div class="container">
      <v-row class="mt-10">
        <v-col cols="12" md="5" class="px-8">
          <p v-for="(line, i) in cast" :key="i">{{ line }}</p>
        </v-col>
        <v-col cols="12" md="7">
          <p v-for="(line, i) in content" :key="i">{{ line }}</p>
        </v-col>
      </v-row>
      <div class="my-10">
        <div v-for="artist in artists" :key="artist.id" class="art">
          <div class="art_i" :style="{ backgroundImage: `url(${artist.image})` }"></div>
          <div class="art_c">
            <div class="art_c_t">{{ artist.title }}</div>
            <h2 class="art_c_n">{{ artist.name }}</h2>
            <div class="art_c_c">{{ artist.intro }}</div>
          </div>
        </div>
      </div>
      <h1 class="nav-title">{{ $t("performance.other") }}</h1>
      <cpo-performance-list :items="items" />
    </div>
  </div>
</template>

<script>
import CpoPerformanceHeader from "@/components/CpoPerformanceHeader.vue";
import CpoPerformanceList from "@/components/CpoPerformanceList.vue";
export default {
  components: { CpoPerformanceHeader, CpoPerformanceList },
  computed: {
    id() {
      return this.$route.params.id;
    },
    content() {
      return (this.item?.content || "").split("\r\n");
    },
    cast() {
      return (this.item?.cast || "").split("\r\n");
    },
    artists() {
      return this.item?.artists || [];
    }
  },
  data() {
    return {
      item: null,
      items: []
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.load();
    next();
  },
  created() {
    this.load();
    this.$axios
      .post("/performance/list", {
        page: 1,
        pageSize: 6,
        filter: [{ operator: "NotEqual", field: "_id", value: this.id }],
        sort: [{ field: "date", asc: false }]
      })
      .then((data) => {
        this.items = data;
      });
  },
  methods: {
    load() {
      this.$axios.post("/performance/getItem", { id: this.$route.params.id }).then((data) => {
        this.item = data;
      });
    }
  }
};
</script>

<style lang="scss">
.performance-view {
  p {
    line-height: 2;
  }
  .art {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: nowrap;
    background: #f0f0f0;
    .art_i {
      width: 450px;
      background-position: center;
      background-size: cover;
      padding-top: 400px;
    }
    .art_c {
      flex: 1 0 0%;
      color: #000;
      padding: 40px 60px;
      .art_c_t {
        font-size: 24px;
        line-height: 1.5em;
        font-weight: bold;
      }
      .art_c_n {
        font-size: 28px;
        line-height: 2em;
        font-weight: bold;
        margin-bottom: 1em;
      }
      .art_c_c {
        color: #7d7d7d;
        height: 10em;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>
